<template>
  <div class="detail-c">
    <div class="detail-top flex bg-white">
      <div class="w-80 flex justify-center items-start">121212</div>
      <div class="flex-1" id="components-form-demo-advanced-search">
        <detail-list class="detail-layout" size="small" slot="headerContent">
          <detail-list-item :key="key" :term="item.name" v-for="(item,key) in accountItem">{{ item.v }}</detail-list-item>
        </detail-list>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    name: 'TopBaseInfoText',
    components: {
      DetailListItem,
      DetailList
    },
    props: {
      manuList: {
        type: Array,
        default: () => []
      }
    },
    // 定义属性
    data () {
      return {
        accountItem: [
          {
            name: '设备名称',
            k: 'accountName',
            v: '223'
          },
          {
            name: '位号',
            k: 'accountName',
            v: '223'
          }, {
            name: '设备类型',
            k: 'accountName',
            v: '223'
          },
          //   {
          //     name: '供水流域',
          //     k: 'accountName',
          //     v: '223'
          //   }, 
          {
            name: '供水流域',
            k: 'accountName',
            v: '223'
          }, {
            name: '设备状态',
            k: 'accountName',
            v: '223'
          }, {
            name: '重要性',
            k: 'accountName',
            v: '223'
          }, {
            name: '负责人',
            k: 'accountName',
            v: '223'
          }, {
            name: '上级设备',
            k: 'accountName',
            v: '223'
          }
        ]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='less' scoped>
  .ant-advanced-search-form {
    padding: 24px;
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }
  .detail-top .ant-upload-list-picture-card .ant-upload-list-item {
    width: 200px;
    height: 200px;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;

    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }
</style>
